import Typography from "@components/Typography";

import styles from "./Licenses.module.css";
const Licenses = () => (
  <div className={styles.root}>
    <Typography variant="h4" component="h2">
      {L.LICENSES_TITLE}
    </Typography>
    <a href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer">
      Youtube Terms of Service
    </a>
    <a
      href="https://policies.google.com/privacy"
      rel="noreferrer"
      target="_blank"
    >
      Google Privacy Policy
    </a>
  </div>
);

export default Licenses;
